import React,{useEffect, useState} from "react";
import AlertModal from "../AlertModal";
import NetworkService from '../../../services/NetworkService';

const NetworkCheck = () => {
    const [isOnline, setNetwork] = useState(window.navigator.onLine);
    const [isShowOnlineOffline, setIsShowOnlineOffline] = useState(false);

    useEffect(() => {
       window.addEventListener("offline", updateNetwork);
       window.addEventListener("online", updateNetwork);

       return () => {
          window.removeEventListener("offline", updateNetwork);
          window.removeEventListener("online", updateNetwork);
       };
    });

    const updateNetwork = async () => {
        let online;
        let prevIsOnline = isOnline;
        
        // Always validate connectivity with actual API call, regardless of browser status
        try {
            const response = await NetworkService.testNetworkStatus();
            online = response && response.success;
        } catch (error) {
            // API call failed, we're actually offline
            online = false;
        }
        
        // Show alert when going offline or coming back online
        if(!online || (online && !prevIsOnline)){
            setIsShowOnlineOffline(true);
        }
        
        // If connection is restored, immediately hide any offline alert and show success
        if(online && !prevIsOnline && isShowOnlineOffline){
            // Hide any existing offline alert immediately
            setIsShowOnlineOffline(false);
            // Show success alert after a brief delay
            setTimeout(() => {
                setIsShowOnlineOffline(true);
            }, 100);
        }
        
        setNetwork(online);

        // Auto-hide success message after 3 seconds
        if(online && prevIsOnline !== online){
            setTimeout(() => {
                setIsShowOnlineOffline(false);
            }, 3000);
        }
     };

    return(
        <>
            {isOnline && isShowOnlineOffline && (
                <AlertModal
                    show={true}
                    type="success"
                    title="Connection Restored"
                    onConfirm={() => setIsShowOnlineOffline(false)}
                    showConfirm={false}
                    timeout={3000}
                >
                    You’re back online.
                </AlertModal>
                )
            }
            {!isOnline && isShowOnlineOffline && (
                <AlertModal
                    show={true}
                    type="warning"
                    title="Connection Lost"
                    onConfirm={() => setIsShowOnlineOffline(false)}
                    showConfirm={true}
                    confirmBtnText="OK"
                    confirmBtnCssClass="btn btn-sm btn-warning text-white border-0"
                >
                    We couldn't process your request. Please check your internet connection and try again.
                </AlertModal>
                )
            }
        </>
    );
 };

 export default NetworkCheck;